// import * as React from 'react';
// import { useState } from 'react';
// import { useLocation } from 'react-router-dom';
// import './FleetOwnView.css';
// import Stack from '@mui/material/Stack';
// import AddIcon from '@mui/icons-material/Add';
// import Dialog from '@mui/material/Dialog';
// // import AppBar from '@mui/material/AppBar';
// // import Toolbar from '@mui/material/Toolbar';
// import IconButton from '@mui/material/IconButton';
// import Typography from '@mui/material/Typography';
// import CloseIcon from '@mui/icons-material/Close';
// import Slide from '@mui/material/Slide';
// import { Box, Button, Grid } from '@mui/material';
// import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow,Select,MenuItem } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import Paper from '@mui/material/Paper';
// import { LineChart } from '@mui/x-charts/LineChart';
// import LocalShippingIcon from '@mui/icons-material/LocalShipping';
// import SwipeLeftIcon from '@mui/icons-material/SwipeLeft';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
// import AccountCircleIcon from '@mui/icons-material/AccountCircle';
// import SouthEastIcon from '@mui/icons-material/SouthEast';
// import { axisClasses } from '@mui/x-charts';
// import Timeline from '@mui/lab/Timeline';
// import TimelineItem from '@mui/lab/TimelineItem';
// import TimelineSeparator from '@mui/lab/TimelineSeparator';
// import TimelineConnector from '@mui/lab/TimelineConnector';
// import TimelineContent from '@mui/lab/TimelineContent';
// import TimelineDot from '@mui/lab/TimelineDot';
// import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
// import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
// import List from '@mui/material/List';
// import ListItem from '@mui/material/ListItem';
// import ListItemText from '@mui/material/ListItemText';
// import FormControlLabel from '@mui/material/FormControlLabel';
// import Checkbox from '@mui/material/Checkbox';
// import Chip from '@mui/material/Chip';
// import { BarChart } from '@mui/x-charts/BarChart';
// import Modal from '@mui/material/Modal';
// import SearchIcon from '@mui/icons-material/Search';
// import {alpha } from '@mui/material/styles';
// import InputBase from '@mui/material/InputBase';
// import InputLabel from '@mui/material/InputLabel';
// import FormControl from '@mui/material/FormControl';
// import FormHelperText from '@mui/material/FormHelperText';
// import '../../mainfavicon.png';
// import StarIcon from '@mui/icons-material/Star';
// import GppGoodIcon from '@mui/icons-material/GppGood';
// import NorthEastIcon from '@mui/icons-material/NorthEast';
// import Inventory2Icon from '@mui/icons-material/Inventory2';

// const Transition = React.forwardRef(function Transition(props, ref) {
//     return <Slide direction="up" ref={ref} {...props} />;
// });
// const Item = styled(Paper)(({ theme }) => ({
//     backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
//     ...theme.typography.body2,
//     padding: theme.spacing(1),
//     textAlign: 'center',
//     color: theme.palette.black,
// }));

// const Search = styled('div')(({ theme }) => ({
//     position: 'relative',
//     borderRadius: theme.shape.borderRadius,
//     backgroundColor: alpha(theme.palette.common.black, 0.1),
//     '&:hover': {
//       backgroundColor: alpha(theme.palette.common.black, 0.15),
//     },
//     marginLeft: 0,
//     width: '100%',
//     [theme.breakpoints.up('sm')]: {
//       marginLeft: theme.spacing(1),
//       width: 'auto',
//     },
//   }));

//   const SearchIconWrapper = styled('div')(({ theme }) => ({
//     padding: theme.spacing(0, 2),
//     height: '100%',
//     position: 'absolute',
//     pointerEvents: 'none',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//   }));

//   const StyledInputBase = styled(InputBase)(({ theme }) => ({
//     color: 'black',
//     width: '100%',
//     '& .MuiInputBase-input': {
//       padding: theme.spacing(1, 1, 1, 0),
//       // vertical padding + font size from searchIcon
//       paddingLeft: `calc(1em + ${theme.spacing(4)})`,
//       transition: theme.transitions.create('width'),
//       [theme.breakpoints.up('sm')]: {
//         width: '12ch',
//         '&:focus': {
//           width: '20ch',
//         },
//       },
//     },
//   }));

// const chartSetting = {
//     // xAxis: [
//     //     {
//     //         label: 'rainfall (mm)',
//     //     },
//     // ],
//     // width: 500,
//     // height: 400,
//     yAxis: [
//         {
//             label: 'rainfall (mm)',
//         },
//     ],
//     // width: 500,
//     // height: 200,
//     sx: {
//         [`.${axisClasses.left} .${axisClasses.label}`]: {
//             transform: 'translate(-20px, 0)',
//         },
//     },
// };

// const dataset = [
//     {
//         jobs: 59,
//         details: 'Jobs',
//     },
//     {
//         dhaba: 52,
//         details: 'Dhaba',
//     },
//     {
//         mech: 76,
//         details: 'Mech',
//     },
//     {
//         convey: 25,
//         details: 'Convey',
//     },
//     {
//         profile: 25,
//         details: 'Profile',
//     },
//     {
//         others: 45,
//         details: 'Others',
//     },
// ];

// const valueFormatter = (value) => `${value}mm`;

// export default function FleetOwnView() {

//     const location = useLocation();
//     const ownerData = location.state?.data || {};
//         React.useEffect(() => {
//         console.log("Fleet Owner view data:", location.state);
//         console.log("Owner data:", ownerData);
//     }, [location.state, ownerData]);
//     const [open, setOpen] = React.useState(true);

//     const handleClickOpen = () => {
//         setOpen(true);
//     };

//     const handleClose = () => {
//         setOpen(false);
//     };
//     const handleFileButtonClick = () => {
//         // Trigger click event on the file input element
//         document.getElementById('fileInput').click();
//     };

//     const [isModalOpen, setIsModalOpen] = useState(false);

//     const toggleModal = () => {
//         setIsModalOpen(!isModalOpen);
//     };

//     const [week, setWeek] = React.useState('');

// const handleChange = (event) => {
//     setWeek(event.target.value);
// };

//     return (
//         <>
//         <div>
//             <React.Fragment>
//                 <Stack direction="row" spacing={2}>
//                     <Typography variant="text" onClick={handleClickOpen} sx={{ color: "black" }}>View</Typography>

//                 </Stack>
//                 <Dialog
//                     fullScreen
//                     open={open}
//                     onClose={handleClose}
//                     TransitionComponent={Transition}
//                     PaperProps={{
//                         style: {
//                             backgroundColor: 'white',
//                         },
//                     }}
//                 >
//                     <Box display="flex" flexDirection="column" >
//                         <Box sx={{ flexGrow: 1 }}>

//                             {/* <Grid container spacing={1}> */}
//                             {/* first column */}
//                             <Grid item xs={12}>
//                                 <Item style={{ backgroundColor: "#fff", height: '40px', paddingInline: "3px" }}>

//                                     <Typography style={{ color: "black", textAlign: "left" }}>
//                                         <IconButton
//                                             edge="start"
//                                             onClick={handleClose}
//                                             aria-label="close"
//                                             style={{ marginLeft: "4px" }}
//                                         >
//                                             <CloseIcon style={{ backgroundColor: "red", color: "white", borderRadius: "50%", fontSize: "20px" }} />
//                                         </IconButton>
//                                         <b>ID: RPTLDIDNOS000001234567890</b>
//                                         <Typography className='btn'>
//                                             <Button variant="contained" sx={{ backgroundColor: "green", '&:hover': { backgroundColor: 'orange' }, textAlign: 'right' }}>Edit</Button>&nbsp;&nbsp;
//                                             <Button variant="contained" sx={{ backgroundColor: 'blue', '&:hover': { backgroundColor: 'orange' }, textAlign: 'right', marginLeft: '10px' }}><AddIcon />Add Ticket</Button>&nbsp;&nbsp;
//                                         </Typography>
//                                     </Typography>
//                                 </Item>
//                             </Grid>
//                             <div style={{ marginBottom: "5px" }}></div>
//                             <Grid item xs={12} md={4}>
//                                 <Grid container spacing={1}>
//                                     <Grid item xs={12} md={2} style={{ color: "black" }}>
//                                         <Grid>
//                                             <Item style={{ backgroundColor: "#fff" }}>
//                                                 <Stack direction="row">
//                                                     {/* <img src='.src/scenes/mainfavicon.png' alt='Drivers profile'/> */}
//                                                     <AccountCircleIcon style={{ color: "grey", fontSize: "100px" }} />
//                                                     <br></br>
//                                                     <Typography style={{ color: "black" }}>Fleet Owner<br></br>
//                                                         <Chip label={<span style={{ color: "red", fontSize: "12px", backgroundColor: "pink",borderRadius: "5px" }}>Standard</span>} />
//                                                     </Typography>
//                                                 </Stack>
//                                                 <br></br>
//                                                 <Stack direction="row">
//                                                 <Stack direction="row">
//                                                     <StarIcon style={{ color: "green", fontSize: "30px" }} />
//                                                     <br></br>
//                                                     <Typography style={{ color: "black", fontSize: "20px" ,width:'auto' }}>5.0<br></br>
//                                                         <Chip label={<span style={{ color: "black", fontSize: "15px"}}>Rating</span>} />
//                                                     </Typography>
//                                                 </Stack>
//                                                 </Stack>
//                                                 <br></br>
//                                                 <Typography style={{ color: "black", fontSize: "20px", textAlign: "left" }}>
//                                                     Details
//                                                 </Typography>
//                                                 <hr></hr>
//                                                 <Typography style={{ color: "#c2c2d6", textAlign: "left" }}>
//                                                     Name: Udhay<br></br>
//                                                     Contact:+91 1234567890 <br></br>
//                                                     Email: driver@roadpilot.co.inactive<br></br>
//                                                     State: Tamil Nadu<br></br>
//                                                     Address: Erani street,Lakshminagar<br></br>
//                                                     Pincode: 600056
//                                                 </Typography><br></br>
//                                                 <Typography style={{ color: "black", fontSize: "20px", textAlign: "left" }}>
//                                                     Company Details
//                                                 </Typography>
//                                                 <hr></hr>
//                                                 <Typography style={{ color: "#c2c2d6", textAlign: "left" }}>
//                                                     Company Name: TUK<br></br>
//                                                     Contact:+91 1234567890 <br></br>
//                                                 </Typography><br></br>
//                                                 <Typography style={{ color: "black", textAlign: "left", fontSize: "20px" }}>Documents</Typography>
//                                                 <hr></hr>
//                                                 <div style={{ marginBottom: "10px" }}></div>
//                                                 <Stack direction="row" style={{ padding: "5px" }}>
//                                                     <Button variant="outlined" style={{ color: "green", fontSize: "8px", borderRadius: '10px' }}>Aadhar Card Front</Button>&nbsp;
//                                                     <Button variant="outlined" style={{ color: "orange", fontSize: "8px",borderRadius: '10px' }}>Aadhar Card Back</Button>&nbsp;
//                                                     {/* <Chip label={<span style={{ color: "green", fontSize: "10px" }}>Aadhar Card Front</span>} variant="outlined" />&nbsp;
//                                                     <Chip label={<span style={{ color: "orange", fontSize: "10px" }}>Aadhar Card Back</span>} variant="outlined" /> */}
//                                                 </Stack>

//                                                 <Stack direction="row" style={{ padding: "5px" }}>
//                                                     <Button variant="outlined" style={{ color: "blue", fontSize: "8px",borderRadius: '10px' }}>FARM Certificate</Button>&nbsp;
//                                                 </Stack>

//                                                 <Stack direction="row" style={{ padding: "5px" }}>
//                                                     <Button variant="contained" style={{ backgroundColor: "green", }}>Edit</Button>&nbsp;&nbsp;
//                                                     <Button variant="outlined" style={{ color: "red" }}>Suspend</Button>
//                                                 </Stack>
//                                             </Item>
//                                         </Grid>
//                                     </Grid>
//                                     {/* second column */}
//                                     <Grid item xs={12} md={7} style={{ color: "black" }}>
//                                         <Grid container spacing={1} style={{ marginBottom: "5px" }}>

//                                             <Grid item xs={12} sm={6} md={6} lg={6}>

//                                                 {/* first row */}

//                                                 <Grid container spacing={1} >
//                                                     <Grid item xs={12} sm={6}>
//                                                         <Item style={{ backgroundColor: "#fff" }}>
//                                                             <Typography gutterBottom variant="subtitle1" style={{ textAlign: "left", fontSize: "20px", color: "#4d4f5c" }}>
//                                                                 Jobs Created
//                                                             </Typography>
//                                                             <Typography variant="body2" gutterBottom style={{ textAlign: "right", color: "#4d4f5c" }}>
//                                                                 <LocalShippingIcon style={{ color: "white", borderRadius: "50%", backgroundColor: "red", paddingInline: "3px" }} />
//                                                             </Typography>
//                                                             <Typography variant="body2" style={{ textAlign: "left", fontSize: "16px" }} color="blue">
//                                                                 275
//                                                             </Typography>
//                                                         </Item>
//                                                     </Grid>

//                                                     <Grid item xs={12} sm={6}>
//                                                         <Item style={{ backgroundColor: "#fff" }}>
//                                                             <Typography gutterBottom variant="subtitle1" style={{ textAlign: "left", fontSize: "20px", color: "#4d4f5c" }}>
//                                                                 Total Application
//                                                             </Typography>
//                                                             <Typography variant="body2" gutterBottom style={{ textAlign: "right", color: "#4d4f5c" }}>
//                                                                 <SwipeLeftIcon style={{ color: "white", borderRadius: "50%", backgroundColor: "purple", paddingInline: "3px" }} />
//                                                             </Typography>
//                                                             <Typography variant="body2" style={{ textAlign: "left", fontSize: "16px" }} color="blue">
//                                                                 275
//                                                             </Typography>
//                                                         </Item>
//                                                     </Grid>
//                                                 </Grid>
//                                             </Grid>

//                                             <Grid item xs={12} sm={6} md={6} lg={6}>

//                                                 {/* first row */}
//                                                 <Grid container spacing={1} >
//                                                     <Grid item xs={12} sm={6}>
//                                                         <Item style={{ backgroundColor: "#fff" }}>
//                                                             <Typography gutterBottom variant="subtitle1" style={{ textAlign: "left", fontSize: "20px", color: "#4d4f5c" }}>
//                                                                 Jobs accepted
//                                                             </Typography>
//                                                             <Typography variant="body2" gutterBottom style={{ textAlign: "right", color: "#4d4f5c" }}>
//                                                                 <CheckCircleIcon style={{ color: "white", borderRadius: "50%", backgroundColor: "green", paddingInline: "3px" }} />
//                                                             </Typography>
//                                                             <Typography variant="body2" style={{ textAlign: "left", fontSize: "16px" }} color="blue">
//                                                                 275
//                                                             </Typography>
//                                                         </Item>
//                                                     </Grid>

//                                                     <Grid item xs={12} sm={6}>
//                                                         <Item style={{ backgroundColor: "#fff" }}>
//                                                             <Typography gutterBottom variant="subtitle1" style={{ textAlign: "left", fontSize: "20px", color: "#4d4f5c" }}>
//                                                                 Jobs Rejected
//                                                             </Typography>
//                                                             <Typography variant="body2" gutterBottom style={{ textAlign: "right", color: "#4d4f5c" }}>
//                                                                 <HourglassBottomIcon style={{ color: "white", borderRadius: "50%", backgroundColor: "blue", paddingInline: "3px" }} />
//                                                             </Typography>
//                                                             <Typography variant="body2" style={{ textAlign: "left", fontSize: "16px" }} color="blue">
//                                                                 275
//                                                             </Typography>
//                                                         </Item>
//                                                     </Grid>
//                                                 </Grid>
//                                             </Grid>
//                                         </Grid>

//                                         <Grid container spacing={1} style={{ marginBottom: "5px" }}>

//                                             <Grid item xs={12} sm={6} md={6} lg={6}>

//                                                 {/* first row */}

//                                                 <Grid container spacing={1} >
//                                                     <Grid item xs={12} sm={6}>
//                                                         <Item style={{ backgroundColor: "#fff" }}>
//                                                             <Typography gutterBottom variant="subtitle1" style={{ textAlign: "left", fontSize: "20px", color: "#4d4f5c" }}>
//                                                                 Convoy Created
//                                                             </Typography>
//                                                             <Typography variant="body2" gutterBottom style={{ textAlign: "right", color: "#4d4f5c" }}>
//                                                                 <LocalShippingIcon style={{ color: "white", borderRadius: "50%", backgroundColor: "red", paddingInline: "3px" }} />
//                                                             </Typography>
//                                                             <Typography variant="body2" style={{ textAlign: "left", fontSize: "16px" }} color="blue">
//                                                                 275
//                                                             </Typography>
//                                                         </Item>
//                                                     </Grid>

//                                                     <Grid item xs={12} sm={6}>
//                                                         <Item style={{ backgroundColor: "#fff" }}>
//                                                             <Typography gutterBottom variant="subtitle1" style={{ textAlign: "left", fontSize: "20px", color: "#4d4f5c" }}>
//                                                                 Trip
//                                                             </Typography>
//                                                             <Typography variant="body2" gutterBottom style={{ textAlign: "right", color: "#4d4f5c" }}>
//                                                                 <SwipeLeftIcon style={{ color: "white", borderRadius: "50%", backgroundColor: "purple", paddingInline: "3px" }} />
//                                                             </Typography>
//                                                             <Typography variant="body2" style={{ textAlign: "left", fontSize: "16px" }} color="blue">
//                                                                 275
//                                                             </Typography>
//                                                         </Item>
//                                                     </Grid>
//                                                 </Grid>
//                                             </Grid>

//                                             <Grid item xs={12} sm={6} md={6} lg={6}>

//                                                 {/* first row */}
//                                                 <Grid container spacing={1} >
//                                                     <Grid item xs={12} sm={6}>
//                                                         <Item style={{ backgroundColor: "#fff" }}>
//                                                             <Typography gutterBottom variant="subtitle1" style={{ textAlign: "left", fontSize: "20px", color: "#4d4f5c" }}>
//                                                                 Total Vehicles
//                                                             </Typography>
//                                                             <Typography variant="body2" gutterBottom style={{ textAlign: "right", color: "#4d4f5c" }}>
//                                                                 <CheckCircleIcon style={{ color: "white", borderRadius: "50%", backgroundColor: "green", paddingInline: "3px" }} />
//                                                             </Typography>
//                                                             <Typography variant="body2" style={{ textAlign: "left", fontSize: "16px" }} color="blue">
//                                                                 275
//                                                             </Typography>
//                                                         </Item>
//                                                     </Grid>

//                                                     <Grid item xs={12} sm={6}>
//                                                         <Item style={{ backgroundColor: "#fff" }}>
//                                                             <Typography gutterBottom variant="subtitle1" style={{ textAlign: "left", fontSize: "20px", color: "#4d4f5c" }}>
//                                                                 Crane Booking
//                                                             </Typography>
//                                                             <Typography variant="body2" gutterBottom style={{ textAlign: "right", color: "#4d4f5c" }}>
//                                                                 <HourglassBottomIcon style={{ color: "white", borderRadius: "50%", backgroundColor: "blue", paddingInline: "3px" }} />
//                                                             </Typography>
//                                                             <Typography variant="body2" style={{ textAlign: "left", fontSize: "16px" }} color="blue">
//                                                                 275
//                                                             </Typography>
//                                                         </Item>
//                                                     </Grid>
//                                                 </Grid>
//                                             </Grid>
//                                         </Grid>

//                                         <Grid container spacing={1} >
//                                             <Grid item xs={12} md={6} style={{ color: "black" }}>
//                                                 <Grid container spacing={1}>
//                                                     <Grid item xs={12}>
//                                                         <Grid>
//                                                             <Item style={{ backgroundColor: "#fff" }}>
//                                                             <Stack direction="row">
//                                                                     <Stack direction="row">
//                                                                         <Inventory2Icon style={{ color: "grey", fontSize: "40px",marginTop:"15px" }} />
//                                                                         <Typography style={{ color: "black", fontSize: "15px" ,width:'auto',marginTop:"15px"}}>Rs. 1450.50<br></br>
//                                                                             <Chip label={<span style={{ color: "black", fontSize: "12px", borderRadius: "10px" }}>Total amount</span>} />
//                                                                         </Typography>
//                                                                     </Stack>
//                                                                     <Stack sx={{marginLeft:'200px',color:'black'}}>
//                                                                         <FormControl sx={{ m: 1, minWidth: 30 }} size="small" style={{color:'black'}}>
//                                                                             {/* <InputLabel id="demo-simple-select-helper-label">Week</InputLabel> */}
//                                                                             <Select
//                                                                                 // labelId="demo-simple-select-helper-label"
//                                                                                 // id="demo-select-small"
//                                                                                 value={week}
//                                                                                 onChange={handleChange}
//                                                                                 sx={{ color: 'black', "& .MuiSelect-icon": { color: 'black' },backgroundColor:'#CCD3CA'}}
//                                                                                 displayEmpty
//                                                                                 inputProps={{ 'aria-label': 'Without label' }}
//                                                                             >
//                                                                                 <MenuItem value={10}>Day</MenuItem>
//                                                                                 <MenuItem value={20}>Week</MenuItem>
//                                                                                 <MenuItem value={30}>Month</MenuItem>
//                                                                                 <MenuItem value={30}>Year</MenuItem>
//                                                                             </Select>
//                                                                         </FormControl>
//                                                                         <Chip label={<span style={{ color: "green", fontSize: "12px", backgroundColor: "#C1F2B0" }}>3.2%<NorthEastIcon /></span>} />
//                                                                     </Stack>
//                                                                 </Stack>
//                                                                 <LineChart
//                                                                     sx={{
//                                                                         '& .MuiAreaElement-series-data': {
//                                                                             fill: "url('#myGradient')",
//                                                                         },
//                                                                     }}
//                                                                     xAxis={[{ data: [1, 2, 3, 5, 8, 10] }]}
//                                                                     series={[
//                                                                         {
//                                                                             id: 'data',
//                                                                             curve: "linear",
//                                                                             data: [2.9, 5.5, 5, 4.6, 6.2, 5.8],
//                                                                             area: true,
//                                                                         },
//                                                                     ]}
//                                                                     maxwidth={300}
//                                                                     height={250}
//                                                                 >
//                                                                     <defs>
//                                                                         <linearGradient id="myGradient" gradientTransform="rotate(90)">
//                                                                             <stop offset="5%" stopColor="#8576FF" />
//                                                                             <stop offset="95%" stopColor="#fff" />
//                                                                         </linearGradient>
//                                                                     </defs>
//                                                                 </LineChart>
//                                                             </Item>
//                                                         </Grid>
//                                                     </Grid>
//                                                     <div style={{ paddingBottom: "5px" }}></div>
//                                                     <Grid item xs={12}>
//                                                         <Grid>
//                                                             <Item style={{ backgroundColor: "#fff" }}>
//                                                                 <BarChart
//                                                                     dataset={dataset}
//                                                                     // yAxis={[{ scaleType: 'band', dataKey: 'month',barGapRatio: 0.9 }]}
//                                                                     // series={[{ dataKey: 'seoul', label: 'Seoul rainfall', valueFormatter }]}
//                                                                     // layout="horizontal"
//                                                                     grid={{ vertical: true }}
//                                                                     {...chartSetting}
//                                                                     yAxis={[{ scaleType: 'band', dataKey: 'details', }]}
//                                                                     series={[
//                                                                         { dataKey: 'jobs', valueFormatter },
//                                                                         { dataKey: 'dhaba', valueFormatter },
//                                                                         { dataKey: 'mech', valueFormatter },
//                                                                         { dataKey: 'profile', valueFormatter },
//                                                                         { dataKey: 'convey', valueFormatter },
//                                                                         { dataKey: 'others', valueFormatter },
//                                                                     ]}
//                                                                     layout="horizontal"
//                                                                     // width={500}
//                                                                     // height={300}
//                                                                     maxwidth={300}
//                                                                     height={250}

//                                                                 />
//                                                             </Item>
//                                                         </Grid>
//                                                     </Grid>
//                                                 </Grid>
//                                             </Grid>

//                                             <Grid item xs={12} md={6} style={{ color: "black" }}>
//                                                 <Item style={{ backgroundColor: "#fff" }}>
//                                                     <Typography style={{ color: "black", textAlign: "left" }}><b>Driver and trip details</b><MoreHorizIcon className='MoreHorizIcon' onClick={toggleModal}></MoreHorizIcon> </Typography>
//                                                     <Stack direction="row">
//                                                         <Typography style={{ color: "black", fontSize: "25px", paddingRight: "20px" }}>40
//                                                             <Chip label={<span style={{ color: "red", fontSize: "12px", backgroundColor: "pink" }}>3.2%<SouthEastIcon /></span>} />
//                                                             <p style={{ color: "grey", fontSize: "16px" }}>Total Drivers</p></Typography><br></br>
//                                                         <div style={{ borderLeft: '2px solid grey', height: '150px', margin: '0 20px' }}></div>
//                                                         <Typography style={{ color: "black" }}>

//                                                             <List>
//                                                                 <ListItem style={{ paddingBottom: "0px" }}>
//                                                                     <FormControlLabel control={<Checkbox defaultChecked style={{ color: "grey", fontSize: "12px" }} />} label={<span style={{ color: "grey", fontSize: "12px" }}>Driver 1</span>} />
//                                                                     <ListItemText style={{ color: "grey", fontSize: "12px" }}>5 trips</ListItemText>
//                                                                 </ListItem>
//                                                                 <ListItem style={{ paddingBottom: "0px" }}>
//                                                                     <FormControlLabel control={<Checkbox defaultChecked style={{ color: "grey", fontSize: "12px" }} />} label={<span style={{ color: "grey", fontSize: "12px" }}>Driver 2</span>} />
//                                                                     <ListItemText style={{ color: "grey", fontSize: "12px" }}>7 trips</ListItemText>
//                                                                 </ListItem>
//                                                                 <ListItem style={{ paddingBottom: "0px" }}>
//                                                                     <FormControlLabel control={<Checkbox defaultChecked style={{ color: "grey", fontSize: "12px" }} />} label={<span style={{ color: "grey", fontSize: "12px" }}>Driver 3</span>} />
//                                                                     <ListItemText style={{ color: "grey", fontSize: "12px" }}>2 trips</ListItemText>
//                                                                 </ListItem>
//                                                             </List>
//                                                         </Typography>
//                                                     </Stack>
//                                                     {/* Modal */}
//                                                     <Modal open={isModalOpen} onClose={toggleModal}>
//                                                         <div style={{ position: 'absolute', top: '50%', left: '50%', width: "600px", height: "400px", transform: 'translate(-50%, -50%)', backgroundColor: '#fff', padding: '20px', color: 'black' }}>
//                                                             {/* Content of your modal */}
//                                                             <Grid container spacing={1}>
//                                                                 <Stack direction="row">
//                                                                     <Grid xs={12}>
//                                                                         <h2>List of Drivers</h2>
//                                                                         <List>
//                                                                             <ListItem disablePadding>
//                                                                                 <ListItemText>Driver 1: 5 trips</ListItemText>
//                                                                             </ListItem>
//                                                                             <ListItem disablePadding>
//                                                                                 <ListItemText>Driver 2: 7 trips</ListItemText>
//                                                                             </ListItem>
//                                                                             <ListItem disablePadding>
//                                                                                 <ListItemText>Driver 3: 2 trips</ListItemText>
//                                                                             </ListItem>
//                                                                             <ListItem disablePadding>
//                                                                                 <ListItemText>Driver 4: 6 trips</ListItemText>
//                                                                             </ListItem>
//                                                                             <ListItem disablePadding>
//                                                                                 <ListItemText>Driver 5: 3 trips</ListItemText>
//                                                                             </ListItem>
//                                                                             <ListItem disablePadding>
//                                                                                 <ListItemText>Driver 6: 5 trips</ListItemText>
//                                                                             </ListItem>
//                                                                             <ListItem disablePadding>
//                                                                                 <ListItemText>Driver 7: 5 trips</ListItemText>
//                                                                             </ListItem>
//                                                                             <ListItem disablePadding>
//                                                                                 <ListItemText>Driver 8: 4 trips</ListItemText>
//                                                                             </ListItem>
//                                                                             <ListItem disablePadding>
//                                                                                 <ListItemText>Driver 9: 1 trips</ListItemText>
//                                                                             </ListItem>
//                                                                             <ListItem disablePadding>
//                                                                                 <ListItemText>Driver 10: 7 trips</ListItemText>
//                                                                             </ListItem>
//                                                                         </List></Grid>
//                                                                     <Grid xs={12} sx={{ justifyContent: "right", marginLeft: "50px" }}>
//                                                                         <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3562.6962717628603!2d80.92190367521856!3d26.75406687674198!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399bfb53706b7d85%3A0xa2330944dc4c56e4!2sRoad%20Pilot%20technologies%20pvt%20ltd!5e0!3m2!1sen!2sin!4v1712893020203!5m2!1sen!2sin"
//                                                                             height="350"
//                                                                             style={{ border: "0", width: "400px" }}
//                                                                             allowfullscreen=""
//                                                                             loading="lazy"
//                                                                         >
//                                                                         </iframe></Grid></Stack>
//                                                             </Grid>

//                                                             <button onClick={toggleModal}>Close</button>
//                                                         </div>
//                                                     </Modal>
//                                                     {/* <div className='map'><SimpleMap></SimpleMap></div> */}
//                                                     {/* <Map></Map> */}
//                                                     <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3562.6962717628603!2d80.92190367521856!3d26.75406687674198!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399bfb53706b7d85%3A0xa2330944dc4c56e4!2sRoad%20Pilot%20technologies%20pvt%20ltd!5e0!3m2!1sen!2sin!4v1712893020203!5m2!1sen!2sin"
//                                                         height="350"
//                                                         style={{ border: "0", width: "100%" }}
//                                                         allowfullscreen=""
//                                                         loading="lazy"
//                                                     >
//                                                     </iframe>

//                                                 </Item>

//                                             </Grid>
//                                         </Grid>

//                                     </Grid>
//                                     {/* third column */}
//                                     <Grid item xs={12} md={3} style={{ color: "black" }}>
//                                         <Grid>
//                                             <Item style={{ backgroundColor: "#fff" }}>
//                                                 <Typography style={{ textAlign: "left", fontSize: "20px", color: "#4d4f5c" }}>User Activity Timeline</Typography>

//                                                 <Search>
//                                                     <SearchIconWrapper style={{color:"black"}}>
//                                                         <SearchIcon style={{color:"black"}}/>
//                                                     </SearchIconWrapper>
//                                                     <StyledInputBase
//                                                        style={{color:"black",borderColor: 'black'}}
//                                                         placeholder="Search…"
//                                                         inputProps={{ 'aria-label': 'search' }}
//                                                     />
//                                                 </Search>

//                                                 <Timeline position="alternate">
//                                                     <TimelineItem>
//                                                         <TimelineOppositeContent color="black">
//                                                             09:30 am
//                                                         </TimelineOppositeContent>
//                                                         <TimelineSeparator>
//                                                             <TimelineDot />
//                                                             <TimelineConnector />
//                                                         </TimelineSeparator>
//                                                         <TimelineContent style={{ color: "black", fontSize: "14px" }}>Earned 500 points<br></br>
//                                                             <Typography style={{ color: "black", fontSize: "10px" }}>Earned 500 points</Typography>
//                                                         </TimelineContent>

//                                                     </TimelineItem>
//                                                     <TimelineItem>
//                                                         <TimelineOppositeContent color="black">
//                                                             10:00 am
//                                                         </TimelineOppositeContent>
//                                                         <TimelineSeparator>
//                                                             <TimelineDot color="secondary" />
//                                                             <TimelineConnector />
//                                                         </TimelineSeparator>
//                                                         <TimelineContent style={{ color: "black", fontSize: "14px" }}>Joined the program<br></br>
//                                                             <Typography style={{ color: "black", fontSize: "10px" }}>Customer Joined the program</Typography>
//                                                         </TimelineContent>
//                                                     </TimelineItem>
//                                                     <TimelineItem>
//                                                         <TimelineOppositeContent color="black">
//                                                             12:00 am
//                                                         </TimelineOppositeContent>
//                                                         <TimelineSeparator>
//                                                             <TimelineDot color="success" />
//                                                             <TimelineConnector />
//                                                         </TimelineSeparator>
//                                                         <TimelineContent style={{ color: "black", fontSize: "14px" }}>8 Invoices have been paid<br></br>
//                                                             <Typography style={{ color: "black", fontSize: "10px" }}>Invoices have been paid to the company</Typography>
//                                                         </TimelineContent>
//                                                     </TimelineItem>
//                                                     <TimelineItem>
//                                                         <TimelineOppositeContent color="black">
//                                                             9:00 am
//                                                         </TimelineOppositeContent>
//                                                         <TimelineSeparator>
//                                                             <TimelineDot color="primary" />
//                                                             <TimelineConnector />
//                                                         </TimelineSeparator>
//                                                         <TimelineContent style={{ color: "black", fontSize: "14px" }}>Order #36675<br></br>
//                                                             <Typography style={{ color: "black", fontSize: "10px" }}>Invoices have been paid to the company</Typography>
//                                                         </TimelineContent>
//                                                     </TimelineItem>
//                                                 </Timeline>
//                                             </Item>
//                                         </Grid>
//                                     </Grid>
//                                 </Grid>
//                             </Grid>
//                             {/* </Grid> */}
//                         </Box>
//                     </Box>
//                 </Dialog>

//             </React.Fragment>

//         </div>

//         </>

//     );
// }

import * as React from "react";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { Box, Button, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import { LineChart } from "@mui/x-charts/LineChart";
import { BarChart } from "@mui/x-charts/BarChart";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
// Icons
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import SwipeLeftIcon from "@mui/icons-material/SwipeLeft";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import SouthEastIcon from "@mui/icons-material/SouthEast";
import NorthEastIcon from "@mui/icons-material/NorthEast";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import StarIcon from "@mui/icons-material/Star";
import SpeedIcon from "@mui/icons-material/Speed";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import GppGoodIcon from "@mui/icons-material/GppGood";
import BusinessIcon from "@mui/icons-material/Business";
import SensorOccupiedIcon from "@mui/icons-material/SensorOccupied";
// Material UI Components
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import FormControlLabel from "@mui/material/FormControlLabel";
import ListSubheader from "@mui/material/ListSubheader";
import Checkbox from "@mui/material/Checkbox";
import Chip from "@mui/material/Chip";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { fleetOwnerApis } from "../../../Data/axios";
import "./FleetOwnView.css";
import EditOwner from "./EditOwner";

function FleetOwnView() {
  const location = useLocation();
  const navigate = useNavigate();
  let ownerData = location.state?.data;
  if (ownerData && ownerData.data) ownerData = ownerData.data;
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState("");
  const [currentDocName, setCurrentDocName] = useState("");
  const [loading, setLoading] = useState(false);
  const [editOwnerOpen, setEditOwnerOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [week, setWeek] = React.useState("");

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const handleChange = (event) => {
    setWeek(event.target.value);
  };

  const formatTimelineDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);

    // Format: "Today, 9:30 AM" or "June 5, 2025, 10:15 AM"
    const isToday = new Date().toDateString() === date.toDateString();
    const isYesterday =
      new Date(Date.now() - 86400000).toDateString() === date.toDateString();

    let prefix = "";
    if (isToday) {
      prefix = "Today, ";
    } else if (isYesterday) {
      prefix = "Yesterday, ";
    } else {
      const dd = String(date.getDate()).padStart(2, "0");
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      prefix = `${dd}-${mm}-${date.getFullYear()}, `;
    }

    return (
      prefix +
      date.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" })
    );
  };

  React.useEffect(() => {
    if (!ownerData) {
      alert("No fleet owner data found");
      navigate("/Users/FleetOwner", { replace: true });
    }
    console.log("Fleet owner data in FleetOwnView:", ownerData);
  }, [ownerData, navigate]);

  if (!ownerData) return null;

  // Helper function for safely displaying data
  const safe = (val, fallback = "N/A") =>
    val !== null && val !== undefined && val !== "" ? val : fallback;

  // Handle document click
  const handleDocumentClick = (docType) => {
    setCurrentDocName(docType);
    setLoading(true);
    setImageModalOpen(true);
    let imgSrc;

    switch (docType) {
      case "Aadhar Card Front":
        imgSrc =
          ownerData?.aadhar_front ||
          "data:image/webp;base64,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";
        break;
      case "Aadhar Card Back":
        imgSrc =
          ownerData?.aadhar_back ||
          "https://th.bing.com/th/id/OIP.fDKECtZEOoD0zYaBdz-j2wHaE3?w=281&h=184&c=7&r=0&o=7&dpr=1.4&pid=1.7&rm=3";
        break;
      case "FARM Certificate":
        imgSrc =
          "https://th.bing.com/th/id/OIP.b-pqDGlWnw-uvCJNIwL2xgHaKe?w=188&h=266&c=7&r=0&o=7&dpr=1.4&pid=1.7&rm=3";
        break;
      default:
        imgSrc = "https://via.placeholder.com/400x250?text=Document+Not+Found";
    }

    setCurrentImage(imgSrc);
    // Simulate loading completion
    setTimeout(() => setLoading(false), 500);
  };

  const handleEditClick = () => {
    setEditOwnerOpen(true);
  };

  const handleOwnerUpdated = () => {
    alert("Fleet owner information updated successfully!");
  };

  return (
    <>
      <div className="text-black">
        <div className="flex items-start -mx-4 space-x-2 overflow-x-auto overflow-y-hidden sm:justify-center flex-nowrap bg-gray-100 text-gray-800">
          <a
            rel="noopener noreferrer"
            href="?profile"
            className="flex items-center flex-shrink-0 px-5 py-2 border-b-4 border-gray-300 text-gray-600"
          >
            Profile
          </a>
          <a
            rel="noopener noreferrer"
            href=""
            className="flex items-center flex-shrink-0 px-5 py-2 border-b-4 border-teal-600 text-gray-900"
          >
            Dashboard
          </a>
          <a
            rel="noopener noreferrer"
            href="?history"
            className="flex items-center flex-shrink-0 px-5 py-2 border-b-4 border-gray-300 text-gray-600"
          >
            History
          </a>
          <a
            rel="noopener noreferrer"
            href="?vehicles"
            className="flex items-center flex-shrink-0 px-5 py-2 border-b-4 border-gray-300 text-gray-600"
          >
            Vehicles
          </a>
        </div>

        {/* Main grid layout */}
        <div className="grid grid-cols-6 grid-rows-8 gap-4">
          {/* Box 1 - Fleet Owner Profile Card */}
          <div className="col-span-2 row-span-1 bg-white rounded-lg shadow">
            <div className="p-3 sm:flex sm:space-x-6 bg-gray-50 rounded-lg text-gray-800">
              <div className="flex-shrink-0 w-full mb-6 h-44 sm:h-32 sm:w-32 sm:mb-0">
                <div className="object-cover object-center w-full h-full rounded bg-gray-500 flex items-center justify-center">
                  {/* If we have image use it, otherwise use placeholder */}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="white"
                    className="w-12 h-12"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                    />
                  </svg>
                </div>
              </div>
              <div className="flex flex-col space-y-4">
                <div>
                  <h2 className="text-2xl font-semibold">
                    {safe(ownerData?.username, "Fleet Owner")}
                  </h2>
                  <span className="text-sm text-gray-600">
                    ID: {safe(ownerData?.user_id)}
                  </span>
                </div>
                <div className="space-y-1">
                  <span className="flex items-center space-x-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                      aria-label="Email address"
                      className="w-4 h-4"
                    >
                      <path
                        fill="currentColor"
                        d="M274.6,25.623a32.006,32.006,0,0,0-37.2,0L16,183.766V496H496V183.766ZM464,402.693,339.97,322.96,464,226.492ZM256,51.662,454.429,193.4,311.434,304.615,256,268.979l-55.434,35.636L57.571,193.4ZM48,226.492,172.03,322.96,48,402.693ZM464,464H48V440.735L256,307.021,464,440.735Z"
                      ></path>
                    </svg>
                    <span className="text-gray-600">
                      {safe(ownerData?.email)}
                    </span>
                  </span>
                  <span className="flex items-center space-x-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                      aria-label="Phonenumber"
                      className="w-4 h-4"
                    >
                      <path
                        fill="currentColor"
                        d="M449.366,89.648l-.685-.428L362.088,46.559,268.625,171.176l43,57.337a88.529,88.529,0,0,1-83.115,83.114l-57.336-43L46.558,362.088l42.306,85.869.356.725.429.684a25.085,25.085,0,0,0,21.393,11.857h22.344A327.836,327.836,0,0,0,461.222,133.386V111.041A25.084,25.084,0,0,0,449.366,89.648Zm-20.144,43.738c0,163.125-132.712,295.837-295.836,295.837h-18.08L87,371.76l84.18-63.135,46.867,35.149h5.333a120.535,120.535,0,0,0,120.4-120.4v-5.333l-35.149-46.866L371.759,87l57.463,28.311Z"
                      ></path>
                    </svg>
                    <span className="text-gray-600">
                      {safe(ownerData?.phone)}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Box 2 - Stats Overview */}
          <div className="col-span-4 row-span-1 col-start-3">
            <section className="p-6 my-1 bg-gray-100 text-gray-800">
              <div className="container grid grid-cols-1 gap-6 mx-auto sm:grid-cols-2 xl:grid-cols-4">
                <div className="flex p-4 space-x-4 rounded-lg md:space-x-6 bg-gray-50 text-gray-800">
                  <div className="flex justify-center p-2 align-middle rounded-lg sm:p-4 bg-teal-600">
                    <LocalShippingIcon className="h-9 w-9 text-gray-100" />
                  </div>
                  <div className="flex flex-col justify-center align-middle">
                    <p className="text-3xl font-semibold leading-none">275</p>
                    <p className="capitalize">Jobs Created</p>
                  </div>
                </div>
                <div className="flex p-4 space-x-4 rounded-lg md:space-x-6 bg-gray-50 text-gray-800">
                  <div className="flex justify-center p-2 align-middle rounded-lg sm:p-4 bg-teal-600">
                    <SwipeLeftIcon className="h-9 w-9 text-gray-100" />
                  </div>
                  <div className="flex flex-col justify-center align-middle">
                    <p className="text-3xl font-semibold leading-none">120</p>
                    <p className="capitalize">Total Applications</p>
                  </div>
                </div>
                <div className="flex p-4 space-x-4 rounded-lg md:space-x-6 bg-gray-50 text-gray-800">
                  <div className="flex justify-center p-2 align-middle rounded-lg sm:p-4 bg-teal-600">
                    <CheckCircleIcon className="h-9 w-9 text-gray-100" />
                  </div>
                  <div className="flex flex-col justify-center align-middle">
                    <p className="text-3xl font-semibold leading-none">86</p>
                    <p className="capitalize">Jobs Accepted</p>
                  </div>
                </div>
                <div className="flex p-4 space-x-4 rounded-lg md:space-x-6 bg-gray-50 text-gray-800">
                  <div className="flex justify-center p-2 align-middle rounded-lg sm:p-4 bg-teal-600">
                    <HourglassBottomIcon className="h-9 w-9 text-gray-100" />
                  </div>
                  <div className="flex flex-col justify-center align-middle">
                    <p className="text-3xl font-semibold leading-none">42</p>
                    <p className="capitalize">Jobs Rejected</p>
                  </div>
                </div>
              </div>
            </section>
          </div>

          {/* Box 3 - User Details */}
          <div className="col-span-2 row-span-4 row-start-2 bg-white rounded-lg shadow">
            <List
              sx={{
                width: "100%",
                maxWidth: 420,
                bgcolor: "white",
                "& .MuiListSubheader-root": {
                  backgroundColor: "white",
                  color: "black",
                  fontWeight: "600",
                  fontSize: "1rem",
                  lineHeight: "2.5rem",
                  borderBottom: "1px solid #e0e0e0",
                },
              }}
              component="nav"
              aria-labelledby="nested-list-subheader"
            >
              <ListSubheader component="div">Details</ListSubheader>
              <ListItemButton>
                <ListItemIcon>
                  <AccountCircleIcon sx={{ color: "#333" }} />
                </ListItemIcon>
                <ListItemText
                  primary="Name"
                  secondary={safe(ownerData?.username)}
                  sx={{
                    "& .MuiListItemText-secondary": {
                      color: "#333",
                    },
                  }}
                />
              </ListItemButton>
              <ListItemButton>
                <ListItemIcon>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="#333"
                    className="w-6 h-6"
                  >
                    <path d="M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.928 5.493a3 3 0 01-3.144 0L1.5 8.67z" />
                    <path d="M22.5 6.908V6.75a3 3 0 00-3-3h-15a3 3 0 00-3 3v.158l9.714 5.978a1.5 1.5 0 001.572 0L22.5 6.908z" />
                  </svg>
                </ListItemIcon>
                <ListItemText
                  primary="Email Address"
                  secondary={safe(ownerData?.email)}
                  sx={{
                    "& .MuiListItemText-secondary": {
                      color: "#333",
                    },
                  }}
                />
              </ListItemButton>
              <ListItemButton>
                <ListItemIcon>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="#333"
                    className="w-6 h-6"
                  >
                    <path
                      fillRule="evenodd"
                      d="M1.5 4.5a3 3 0 013-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 01-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 006.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 011.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 01-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5z"
                      clipRule="evenodd"
                    />
                  </svg>
                </ListItemIcon>
                <ListItemText
                  primary="Phone Number"
                  secondary={safe(ownerData?.phone)}
                  sx={{
                    "& .MuiListItemText-secondary": {
                      color: "#333",
                    },
                  }}
                />
              </ListItemButton>
              <ListItemButton>
                <ListItemIcon>
                  <BusinessIcon sx={{ color: "#333" }} />
                </ListItemIcon>
                <ListItemText
                  primary="Company Name"
                  secondary={safe(ownerData?.company_name, "TUK")}
                  sx={{
                    "& .MuiListItemText-secondary": {
                      color: "#333",
                    },
                  }}
                />
              </ListItemButton>
              <ListItemButton>
                <ListItemIcon>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="#333"
                    className="w-6 h-6"
                  >
                    <path
                      fillRule="evenodd"
                      d="M11.54 22.351l.07.04.028.016a.76.76 0 00.723 0l.028-.015.071-.041a16.975 16.975 0 001.144-.742 19.58 19.58 0 002.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 00-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 002.682 2.282 16.975 16.975 0 001.145.742zM12 13.5a3 3 0 100-6 3 3 0 000 6z"
                      clipRule="evenodd"
                    />
                  </svg>
                </ListItemIcon>
                <ListItemText
                  primary="Address"
                  secondary={`${safe(ownerData?.address)}, ${safe(
                    ownerData?.state
                  )}, ${safe(ownerData?.pincode)}`}
                  sx={{
                    "& .MuiListItemText-secondary": {
                      color: "#333",
                    },
                  }}
                />
              </ListItemButton>
              <ListSubheader component="div">Documents</ListSubheader>
              <ListItemButton
                onClick={() => handleDocumentClick("Aadhar Card Front")}
              >
                <ListItemIcon>
                  <GppGoodIcon sx={{ color: "#333" }} />
                </ListItemIcon>
                <ListItemText primary="Aadhar Card Front" />
              </ListItemButton>
              <ListItemButton
                onClick={() => handleDocumentClick("Aadhar Card Back")}
              >
                <ListItemIcon>
                  <GppGoodIcon sx={{ color: "#333" }} />
                </ListItemIcon>
                <ListItemText primary="Aadhar Card Back" />
              </ListItemButton>
              <ListItemButton
                onClick={() => handleDocumentClick("FARM Certificate")}
              >
                <ListItemIcon>
                  <SensorOccupiedIcon sx={{ color: "#333" }} />
                </ListItemIcon>
                <ListItemText primary="FARM Certificate" />
              </ListItemButton>
              <div className="flex flex-col space-y-4 justify-center mt-6 mb-4 px-4">
                <button className="w-full py-2 bg-green-600 text-white rounded-md hover:bg-green-700 flex items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 mr-1"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  Verify Fleet Owner
                </button>
                <div className="flex justify-center space-x-4">
                  <button
                    onClick={handleEditClick}
                    className="px-4 py-2 bg-teal-600 text-white rounded-md hover:bg-teal-700 flex-1"
                  >
                    Edit
                  </button>
                  <button className="px-4 py-2 bg-gray-200 text-gray-700 border border-gray-300 rounded-md hover:bg-gray-300 flex-1">
                    Suspend
                  </button>
                </div>
              </div>
            </List>
          </div>

          {/* Box 4 - Performance Overview */}
          <div className="col-span-2 row-span-2 col-start-3 row-start-2 bg-white p-4 rounded-lg shadow">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold text-gray-800">
                Performance Overview
              </h3>
              <MoreHorizIcon className="text-gray-500 cursor-pointer" />
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="flex items-center p-3 rounded-lg bg-blue-50">
                <StarIcon className="h-8 w-8 text-blue-500 mr-3" />
                <div>
                  <p className="text-2xl font-semibold">5.0</p>
                  <p className="text-sm text-gray-600">Average Rating</p>
                </div>
              </div>

              <div className="flex items-center p-3 rounded-lg bg-green-50">
                <SpeedIcon className="h-8 w-8 text-green-500 mr-3" />
                <div>
                  <p className="text-2xl font-semibold">40</p>
                  <p className="text-sm text-gray-600">Total Drivers</p>
                </div>
              </div>

              <div className="flex items-center p-3 rounded-lg bg-yellow-50">
                <DirectionsCarIcon className="h-8 w-8 text-yellow-500 mr-3" />
                <div>
                  <p className="text-2xl font-semibold">68</p>
                  <p className="text-sm text-gray-600">Total Vehicles</p>
                </div>
              </div>

              <div className="flex items-center p-3 rounded-lg bg-purple-50">
                <AccessTimeIcon className="h-8 w-8 text-purple-500 mr-3" />
                <div>
                  <p className="text-2xl font-semibold">92%</p>
                  <p className="text-sm text-gray-600">On-time Rate</p>
                </div>
              </div>
            </div>
          </div>

          {/* Box 5 - Drivers and trip details */}
          <div className="col-span-2 row-span-2 col-start-3 row-start-4 bg-white p-3 rounded-lg shadow">
            <div className="border-b pb-2 mb-2">
              <h3 className="text-lg font-medium text-gray-800 flex items-center justify-between">
                <span className="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="w-5 h-5 mr-2 text-teal-600"
                  >
                    <path d="M3.375 4.5C2.339 4.5 1.5 5.34 1.5 6.375V13.5h12V6.375c0-1.036-.84-1.875-1.875-1.875h-8.25zM13.5 15h-12v2.625c0 1.035.84 1.875 1.875 1.875h.375a3 3 0 116 0h3a.75.75 0 00.75-.75V15z" />
                    <path d="M8.25 19.5a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zM15.75 6.75a.75.75 0 00-.75.75v11.25c0 .087.015.17.042.248a3 3 0 015.958.464c.853-.175 1.522-.935 1.464-1.883a18.659 18.659 0 00-3.732-10.104 1.837 1.837 0 00-1.47-.725H15.75z" />
                    <path d="M19.5 19.5a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0z" />
                  </svg>
                  Drivers and Trip Details
                </span>
                <MoreHorizIcon
                  className="cursor-pointer"
                  onClick={toggleModal}
                />
              </h3>
            </div>
            <div className="flex">
              {/* <div className="flex-1 border-r pr-4">  */}
              {/* <div className="text-2xl font-semibold">40</div>
                <div className="flex items-center">
                  <Chip 
                    label={<span className="flex items-center text-red-600 text-xs"><SouthEastIcon fontSize="small" /> 3.2%</span>}  
                    size="small" 
                    className="bg-pink-100" 
                  />
                </div> */}
              {/* <p className="text-gray-600 text-sm mt-1">Total Drivers</p> */}
              {/* </div> */}
              {/* <div className="flex-1 pl-4"> */}
              {/* <List dense>
                  <ListItem disablePadding>
                    <FormControlLabel
                      control={<Checkbox defaultChecked style={{ color: "grey", fontSize: "12px" }} />}
                      label={<span style={{ color: "grey", fontSize: "12px" }}>Driver 1</span>}
                    />
                    <ListItemText style={{ color: "grey", fontSize: "12px" }}>5 trips</ListItemText>
                  </ListItem>
                  <ListItem disablePadding>
                    <FormControlLabel
                      control={<Checkbox defaultChecked style={{ color: "grey", fontSize: "12px" }} />}
                      label={<span style={{ color: "grey", fontSize: "12px" }}>Driver 2</span>}
                    />
                    <ListItemText style={{ color: "grey", fontSize: "12px" }}>7 trips</ListItemText>
                  </ListItem>
                  <ListItem disablePadding>
                    <FormControlLabel
                      control={<Checkbox defaultChecked style={{ color: "grey", fontSize: "12px" }} />}
                      label={<span style={{ color: "grey", fontSize: "12px" }}>Driver 3</span>}
                    />
                    <ListItemText style={{ color: "grey", fontSize: "12px" }}>2 trips</ListItemText>
                  </ListItem>
                </List> */}
              {/* </div> */}
            </div>
            <div className="h-[180px] mt-2">
              <iframe
                title="Driver Location"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                loading="lazy"
                allowFullScreen
                src="https://www.openstreetmap.org/export/embed.html?bbox=80.54489135742189%2C26.639480166462246%2C81.15257263183595%2C27.03649860918967&amp;layer=mapnik"
              ></iframe>
            </div>
          </div>

          {/* Box 6 - User Activity Timeline */}
          <div className="col-span-2 row-span-4 col-start-5 row-start-2 bg-white p-4 rounded-lg shadow">
            <h3 className="text-lg font-semibold text-gray-800 border-b pb-2 mb-4">
              User Activity
            </h3>

            <div className="overflow-y-auto max-h-[350px] pr-2">
              <div className="space-y-4">
                {/* Sample timeline items */}
                <div className="flex">
                  <div className="flex flex-col items-center mr-4">
                    <div className="w-3 h-3 bg-teal-600 rounded-full"></div>
                    <div className="w-0.5 h-full bg-gray-200"></div>
                  </div>
                  <div className="bg-gray-50 p-3 rounded-lg shadow-sm flex-1 mb-2">
                    <span className="text-xs font-medium text-gray-500 block mb-1">
                      Today, 9:30 AM
                    </span>
                    <p className="text-sm font-medium text-gray-800">
                      Earned 500 points
                    </p>
                    <p className="text-xs text-gray-600 mt-1">
                      Earned 500 points through the loyalty program
                    </p>
                  </div>
                </div>

                <div className="flex">
                  <div className="flex flex-col items-center mr-4">
                    <div className="w-3 h-3 bg-blue-600 rounded-full"></div>
                    <div className="w-0.5 h-full bg-gray-200"></div>
                  </div>
                  <div className="bg-gray-50 p-3 rounded-lg shadow-sm flex-1 mb-2">
                    <span className="text-xs font-medium text-gray-500 block mb-1">
                      Today, 10:00 AM
                    </span>
                    <p className="text-sm font-medium text-gray-800">
                      Joined the program
                    </p>
                    <p className="text-xs text-gray-600 mt-1">
                      Customer Joined the program
                    </p>
                  </div>
                </div>

                <div className="flex">
                  <div className="flex flex-col items-center mr-4">
                    <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                    <div className="w-0.5 h-full bg-gray-200"></div>
                  </div>
                  <div className="bg-gray-50 p-3 rounded-lg shadow-sm flex-1 mb-2">
                    <span className="text-xs font-medium text-gray-500 block mb-1">
                      Today, 12:00 PM
                    </span>
                    <p className="text-sm font-medium text-gray-800">
                      8 Invoices have been paid
                    </p>
                    <p className="text-xs text-gray-600 mt-1">
                      Invoices have been paid to the company
                    </p>
                  </div>
                </div>

                <div className="flex">
                  <div className="flex flex-col items-center mr-4">
                    <div className="w-3 h-3 bg-purple-500 rounded-full"></div>
                  </div>
                  <div className="bg-gray-50 p-3 rounded-lg shadow-sm flex-1 mb-2">
                    <span className="text-xs font-medium text-gray-500 block mb-1">
                      Yesterday, 9:00 AM
                    </span>
                    <p className="text-sm font-medium text-gray-800">
                      Order #36675
                    </p>
                    <p className="text-xs text-gray-600 mt-1">
                      Invoices have been paid to the company
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Box 7 - Revenue Trend */}
          {/* <div className="col-span-3 row-span-3 row-start-6 bg-white p-4 rounded-lg shadow">
            <div className="flex justify-between items-center mb-2">
              <h3 className="text-lg font-medium text-gray-800">Revenue Trend</h3>
              <div className="flex items-center">
                <Stack direction="row" spacing={1}>
                  <Chip 
                    label={<span className="flex items-center text-green-600 text-xs"><NorthEastIcon fontSize="small" /> 3.2%</span>}  
                    size="small" 
                    className="bg-green-100" 
                  />
                  <FormControl sx={{ minWidth: 80 }} size="small">
                    <Select
                      value={week}
                      onChange={handleChange}
                      displayEmpty
                      sx={{ bgcolor: '#f9fafb', fontSize: '0.875rem' }}
                    >
                      <MenuItem value="">Week</MenuItem>
                      <MenuItem value={10}>Day</MenuItem>
                      <MenuItem value={20}>Month</MenuItem>
                      <MenuItem value={30}>Year</MenuItem>
                    </Select>
                  </FormControl>
                </Stack>
              </div>
            </div>
            <div className="flex items-center mb-4">
              <Inventory2Icon style={{ color: "grey", fontSize: "30px", marginRight: "8px" }} />
              <div>
                <p className="text-lg font-semibold">Rs. 1,450.50</p>
                <span className="text-sm text-gray-500">Total amount</span>
              </div>
            </div>
            <LineChart
              height={250}
              series={[
                {
                  data: [2.9, 5.5, 5, 4.6, 6.2, 5.8, 4.8],
                  label: "Revenue",
                  color: "#8576FF",
                  curve: "natural",
                  area: true,
                },
              ]}
              xAxis={[
                {
                  data: [1, 2, 3, 5, 8, 10, 12],
                  scaleType: "point",
                  tickLabelStyle: {
                    angle: 0,
                    textAnchor: "middle",
                    fill: "#333333",
                  },
                },
              ]}
              yAxis={[
                {
                  tickLabelStyle: {
                    fill: "#333333",
                  },
                },
              ]}
              sx={{
                '.MuiAreaElement-series-data': {
                  fill: 'url(#myGradient)',
                },
                '.MuiLineElement-root': {
                  strokeWidth: 2,
                },
              }}
            >
              <defs>
                <linearGradient id="myGradient" gradientTransform="rotate(90)">
                  <stop offset="5%" stopColor="#8576FF" />
                  <stop offset="95%" stopColor="#fff" />
                </linearGradient>
              </defs>
            </LineChart>
          </div> */}

          {/* Box 8 - Activity Distribution */}
          {/* <div className="col-span-3 row-span-3 col-start-4 row-start-6 bg-white p-4 rounded-lg shadow">
            <h3 className="text-lg font-medium text-gray-800 mb-4">
              Activity Distribution
            </h3>
            <BarChart
              dataset={[
                { details: 'Jobs', jobs: 59 },
                { details: 'Dhaba', dhaba: 52 },
                { details: 'Mech', mech: 76 },
                { details: 'Convey', convey: 25 },
                { details: 'Profile', profile: 25 },
                { details: 'Others', others: 45 },
              ]}
              height={250}
              yAxis={[{ scaleType: 'band', dataKey: 'details' }]}
              series={[
                { dataKey: 'jobs', label: 'Jobs', valueFormatter: (value) => `${value}` },
                { dataKey: 'dhaba', label: 'Dhaba', valueFormatter: (value) => `${value}` },
                { dataKey: 'mech', label: 'Mech', valueFormatter: (value) => `${value}` },
                { dataKey: 'convey', label: 'Convey', valueFormatter: (value) => `${value}` },
                { dataKey: 'profile', label: 'Profile', valueFormatter: (value) => `${value}` },
                { dataKey: 'others', label: 'Others', valueFormatter: (value) => `${value}` },
              ]}
              layout="horizontal"
              grid={{ vertical: true, horizontal: false }}
              slotProps={{
                legend: {
                  hidden: true,
                },
              }}
            />
          </div> */}
        </div>

        {/* Modal for driver list */}
        <Modal open={isModalOpen} onClose={toggleModal}>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white p-6 rounded-lg shadow-xl max-w-4xl w-full max-h-[80vh] overflow-auto">
            {/* <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-semibold">List of Drivers</h2>
              <IconButton onClick={toggleModal} size="small">
                <CloseIcon />
              </IconButton>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="space-y-1">
                <h3 className="font-medium text-gray-700 mb-2">Driver Details</h3>
                <div className="overflow-y-auto max-h-[400px]">
                  <List>
                    <ListItem disablePadding>
                      <ListItemText>Driver 1: 5 trips</ListItemText>
                    </ListItem>
                    <ListItem disablePadding>
                      <ListItemText>Driver 2: 7 trips</ListItemText>
                    </ListItem>
                    <ListItem disablePadding>
                      <ListItemText>Driver 3: 2 trips</ListItemText>
                    </ListItem>
                    <ListItem disablePadding>
                      <ListItemText>Driver 4: 6 trips</ListItemText>
                    </ListItem>
                    <ListItem disablePadding>
                      <ListItemText>Driver 5: 3 trips</ListItemText>
                    </ListItem>
                    <ListItem disablePadding>
                      <ListItemText>Driver 6: 5 trips</ListItemText>
                    </ListItem>
                    <ListItem disablePadding>
                      <ListItemText>Driver 7: 5 trips</ListItemText>
                    </ListItem>
                    <ListItem disablePadding>
                      <ListItemText>Driver 8: 4 trips</ListItemText>
                    </ListItem>
                    <ListItem disablePadding>
                      <ListItemText>Driver 9: 1 trips</ListItemText>
                    </ListItem>
                    <ListItem disablePadding>
                      <ListItemText>Driver 10: 7 trips</ListItemText>
                    </ListItem>
                  </List>
                </div>
              </div> */}

            <div>
              <h3 className="font-medium text-gray-700 mb-2">Location Map</h3>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3562.6962717628603!2d80.92190367521856!3d26.75406687674198!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399bfb53706b7d85%3A0xa2330944dc4c56e4!2sRoad%20Pilot%20technologies%20pvt%20ltd!5e0!3m2!1sen!2sin!4v1712893020203!5m2!1sen!2sin"
                width="100%"
                height="350"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </Modal>

        {/* Modal for document preview */}
        <Modal
          open={imageModalOpen}
          onClose={() => setImageModalOpen(false)}
          aria-labelledby="document-modal-title"
          aria-describedby="document-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "auto",
              maxWidth: "80%",
              maxHeight: "80%",
              bgcolor: "background.paper",
              boxShadow: 24,
              borderRadius: 2,
              p: 3,
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <Typography
                id="document-modal-title"
                variant="h6"
                component="h2"
                sx={{ fontFamily: "Ubuntu, sans-serif" }}
              >
                {currentDocName}
              </Typography>
              <IconButton onClick={() => setImageModalOpen(false)} size="small">
                <CloseIcon />
              </IconButton>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: 300,
                minWidth: 400,
              }}
            >
              {loading ? (
                <div className="flex items-center justify-center">
                  <div className="w-12 h-12 border-4 border-t-blue-500 border-r-transparent border-b-blue-500 border-l-transparent rounded-full animate-spin"></div>
                </div>
              ) : (
                <img
                  src={currentImage}
                  alt={`${currentDocName} document`}
                  style={{
                    maxWidth: "100%",
                    maxHeight: "60vh",
                    objectFit: "contain",
                  }}
                />
              )}
            </Box>
          </Box>
        </Modal>
        <EditOwner
          open={editOwnerOpen}
          handleClose={() => setEditOwnerOpen(false)}
          ownerData={ownerData}
          onOwnerUpdated={handleOwnerUpdated}
        />
      </div>
    </>
  );
}

export default FleetOwnView;
